import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInOutHeight } from '@app/animations/fade-in-out.animation';
import { AppConfig } from '@app/app.config';
import { ModalProvider } from '@app/components/_shared/modal/modal.component';
import { LoginComponent } from '@app/components/account/login/login.component';
import { equalsValidator } from '@app/directives/equals-validator.directive';
import { PasswordResetModel } from '@app/models/auth/passwordReset.model';
import { PasswordResetResponse } from '@app/models/auth/passwordResetResponse.model';
import { AuthService } from '@app/services/auth.service';
import { LocalisationService } from '@app/services/localisation.service';
import { ResetPasswordService } from '@app/services/reset-password.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  animations: [fadeInOutHeight]
})
export class ResetPasswordComponent implements OnInit {
  static route: string = 'reset-password';
  static routeParams: string = '?validation=';

  locale: any = {};

  resetPasswordForm: FormGroup;
  resetPasswordSubmitted: boolean = false;
  passwordLength: number;

  validationToken: string;

  showPassword: boolean = false;
  passwordType: string = 'password';
  showConfirmPassword: boolean = false;
  confirmPasswordType: string = 'password';
  passwordToggleText: string = 'Show';
  public formSubmitted: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private localistaion: LocalisationService,
    private resetPasswordService: ResetPasswordService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    public modal: ModalProvider
  ) {}

  ngOnInit() {
    this.locale = this.localistaion.getTranslationsForComponent('ResetPasswordComponent');
    this.passwordLength = AppConfig.passwordLength;

    this.route.queryParams.subscribe(params => {
      this.validationToken = params['validation'];
      if (!this.validationToken) {
        this.router.navigate([`/${LoginComponent.route}`]);
      }

      this.resetPasswordForm = this.formBuilder.group(
        {
          email: [
            params['email'] || null,
            [Validators.required, Validators.pattern(AppConfig.emailRegex)]
          ],
          password: [null, [Validators.required, Validators.minLength(this.passwordLength)]],
          password_confirmation: [null, [Validators.required]],
          token: [this.validationToken, Validators.required]
        },
        {
          validator: equalsValidator('password', 'password_confirmation')
        }
      );
    });
  }

  setFormSubmitted(value) {
    this.formSubmitted = value;
  }

  resetPassword(model: PasswordResetModel) {
    this.resetPasswordSubmitted = true;

    if (!this.resetPasswordForm.valid) {
      return;
    }

    this.setFormSubmitted(true);
    this.authService
      .resetPassword(model)
      .finally(() => {
        this.setFormSubmitted(false);
      })
      .subscribe(
        succeed => {
          this.modal
            .create(this.locale.successModalTitle, this.locale.successModalMessage)
            .then(result => {
              this.router.navigate(['/login']);
            });
        },
        (err: PasswordResetResponse) => {
          if (err.returnCode.errorCode == '10201') {
            this.resetPasswordService.setPasswordTokenError(true); // Sharing data as a service
            this.router.navigate(['/forgotten-login']);
          } else {
            this.modal.create(this.locale.errorModalTitle, err.returnCode.message);
          }
        }
      );
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
    this.passwordType = this.showPassword ? 'text' : 'password';
  }

  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
    this.confirmPasswordType = this.showConfirmPassword ? 'text' : 'password';
  }

  validate() {
    if (
      this.resetPasswordForm.controls['password_confirmation'].value ==
      this.resetPasswordForm.controls['password'].value
    ) {
      let error = { unequalValues: false };
      this.resetPasswordForm.controls['password_confirmation'].setErrors(error);
      this.resetPasswordForm.controls['password_confirmation'].updateValueAndValidity();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/account/reset-password/reset-password.component.ts